import styled, { StyledComponentBase } from 'styled-components';

interface IFlexProps {
    align?: string;
    flexWrap?: string;
    className?: string;
}
interface IBoxProps {
    width?: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    theme?: any;
}
// These are the same defaults as styled-system used to have.
// Set them like this for backwards compatibility reasons since we've removed reflexbox lib
const defaultTheme = {
    breakpoints: ['40em', '52em', '64em'],
    fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 96, 128],
    space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};

const createMediaQuery = (widths: number[] = []) => (n: string, i: number) =>
    `@media screen and (min-width: ${n}) { width: ${widths[i + 1] * 100}% }`;

export const Box: StyledComponentBase<'div', IBoxProps> = styled.div<IBoxProps>`
    box-sizing: border-box;
    margin: 0;
    min-width: 0;
    width: 100%;
    ${props => {
        const theme = { ...defaultTheme, ...props.theme };

        return theme.breakpoints.map(createMediaQuery(props.width)).join('');
    }}
`;

Box.defaultProps = {
    theme: defaultTheme,
    width: []
};

Box.displayName = 'Box';

export const Flex: React.ComponentType<IFlexProps> = styled(Box)`
    display: flex;
    align-items: ${props => props.align};
    flex-wrap: ${props => props.flexWrap};
`;
